

const SIZE_TYPES = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});

export default SIZE_TYPES;
